import { render, staticRenderFns } from "./ProductExpTable.vue?vue&type=template&id=a85cb12c&scoped=true&"
import script from "./ProductExpTable.vue?vue&type=script&lang=js&"
export * from "./ProductExpTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductExpTable.vue?vue&type=style&index=0&id=a85cb12c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85cb12c",
  null
  
)

export default component.exports